<template>
	<div class="w-full h-full flex flex-col items-center px-3">
		<!-- OBJECT CLASSES -->
		<div
			id="object-classes-container"
			class="w-full"
			:class="{
				active: hasObjectClassSelected,
			}"
		>
			<button
				class="btn btn-dropdown"
				@click="ToggleObjectClassDropdown"
			>
				<span>TIPO</span>
				<i
					class="fas"
					:class="{
						'fa-chevron-right':
							!filters.opened.objectClassesDropdown,
						'fa-chevron-down': filters.opened.objectClassesDropdown,
					}"
				></i>
			</button>
			<div
				class="dropdown-list"
				v-if="filters.opened.objectClassesDropdown"
			>
				<ul class="w-full flex flex-column">
					<li class="w-full list-unstyled flex flex-col my-1">
						<InputCheck
							inputId="select_all"
							inputName="select_all"
							text="TODOS"
							v-model="objectClassesSelectAll"
							:classes="{
								root: 'py-1',
								span: 'font-bold',
							}"
						/>
					</li>
					<li
						v-for="(object_class, index) in OBJECT_CLASSES"
						:key="`${object_class.type}-${index}`"
						class="w-full list-unstyled flex flex-col my-1"
					>
						<div class="form-check py-1">
							<InputCheck
								:inputId="object_class.type"
								:inputName="object_class.type"
								:text="object_class.label"
								v-model="objectClasses[object_class.type]"
								:classes="{
									span: 'font-bold',
								}"
							/>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<hr />
		<!-- MODULES AND MODALITIES -->
		<div
			id="modules-container"
			class="w-full"
			:class="{
				active: hasModulesOrModalitiesSelected,
			}"
		>
			<button
				class="btn btn-dropdown"
				@click="ToggleModulesDropdown"
			>
				<span>MÓDULOS / MODALIDADES</span>
				<i
					class="fas"
					:class="{
						'fa-chevron-right': !filters.opened.modulesDropdown,
						'fa-chevron-down': filters.opened.modulesDropdown,
					}"
				></i>
			</button>
			<div
				class="dropdown-list"
				v-if="filters.opened.modulesDropdown"
			>
				<div class="w-full px-0 hierarchy-select">
					<HierarchySelect
						ref="hierarchySelect"
						:value="filters.modules"
						keyName="modules"
						identifier="module"
						:level="1"
						@change="ChangeFiltersHandler"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import InputCheck from '@/components/shared/InputCheck.vue'
	import { useError, useEachRecursively } from '@/composables'
	export default {
		name: 'Filters',
		components: {
			InputCheck,
		},
		data() {
			return {
				OBJECT_CLASSES: [
					{ type: 'calculus', label: 'Cálculo' },
					{ type: 'classification', label: 'Classificação' },
					{ type: 'description', label: 'Descrição' },
					{ type: 'information', label: 'Informação' },
					{ type: 'observation', label: 'Observação' },
					{ type: 'var_dynamic', label: 'Variáveis dinâmicas' },
					{ type: 'var_struct', label: 'Variáveis estruturais' },
				],
				objectClassesSelectAll: false,
				objectClasses: {
					calculus: false,
					classification: false,
					description: false,
					information: false,
					observation: false,
					var_dynamic: false,
					var_struct: false,
				},
				filters: {
					modules: [],
					opened: {
						objectClassesDropdown: true,
						modulesDropdown: true,
					},
				},
			}
		},

		computed: {
			hasObjectClassSelected() {
				return false
			},
			hasModulesOrModalitiesSelected() {
				return false
			},
		},
		watch: {
			objectClassesSelectAll: {
				handler(val) {
					for (const key of Object.keys(this.objectClasses)) {
						this.objectClasses[key] = val
					}
				},
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetContentModulesAndModalities() {
				this.StartLoading()

				return window.api
					.call('get', '/content/modules-and-modalities')
					.then(async ({ status, data }) => {
						if (status !== 200) {
							useError(
								'Erro ao carregar os Módulos e Modalidades de conteúdo!'
							)
							return
						}

						this.filters.modules =
							await this.StructFiltersHierarchyRecursively(
								data.modules
							)
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async StructFiltersHierarchyRecursively(hierarchy) {
				hierarchy = await Promise.all(
					hierarchy.map(async item => {
						const newItem = {
							id: item.id,
							name: item.name,
							selected: false,
							expanded: false,
							...this.GetCurrentStructure(item),
						}

						if (newItem.children) {
							newItem.children =
								await this.StructFiltersHierarchyRecursively(
									newItem.children
								)

							delete newItem[newItem.oldChildrenKey]
							delete newItem.oldChildrenKey
						} else {
							delete newItem.children
						}

						return newItem
					})
				)

				return hierarchy
			},
			GetCurrentStructure(item) {
				const current = {}

				if (item.modalities && Array.isArray(item.modalities)) {
					current.key = 'modules'
					current.children = item.modalities
					current.identifier = 'module'
					current.oldChildrenKey = 'modalities'
				} else {
					current.key = 'modalities'
					current.children = null
					current.identifier = 'modality'
				}

				return current
			},
			ChangeFiltersHandler() {},
			ToggleObjectClassDropdown() {
				this.filters.opened.objectClassesDropdown =
					!this.filters.opened.objectClassesDropdown
			},
			ToggleModulesDropdown() {
				this.filters.opened.modulesDropdown =
					!this.filters.opened.modulesDropdown
			},
			ClearFilters() {
				this.ClearObjectClasses()
				this.ClearModulesAndModalities()
			},
			ClearObjectClasses() {
				for (const key of Object.keys(this.objectClasses)) {
					this.objectClasses[key] = false
				}

				this.objectClassesSelectAll = false
			},
			ClearModulesAndModalities() {
				useEachRecursively(this.filters.modules, item => {
					item.selected = false
					item.expanded = false
				})

				this.$refs.hierarchySelect.selectAll = false
			},
		},
		beforeMount() {
			this.GetContentModulesAndModalities()
		},
	}
</script>

<style lang="scss" scoped>
	.form-check {
		span {
			font-size: 1.063rem;
		}
	}

	.btn-dropdown {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.dropdown-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		border: 1px solid var(--hr);
		border-bottom-left-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem;
		overflow: hidden;
		padding: 0.3rem 0 0.3rem 0.75rem;
	}
</style>
